import axios from "axios";
import { toast } from "sonner";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Surface RBAC 403s uniformly across the app
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 403) {
      const detail = err.response.data?.detail || "Acesso negado";
      toast.error("Acesso negado", { description: detail });
    }
    return Promise.reject(err);
  }
);
